import React, { Component, Fragment } from 'react'
import { Redirect } from 'react-router-dom'
import { Button, Col, Divider, Popconfirm, Row } from 'antd'
import MainLayout from 'Hoc/MainLayout'
import AgreementForm from 'Components/AgreementForm'
import RefsTable from 'Components/RefsTable'
import SelectedRefsTable from 'Components/SelectedRefsTable'
import Summary from 'Components/Summary'
import { AlignRightColumn, MarginLeftButton } from 'Common/styled'

import { isEmptyObject } from 'Common/utils'
import api from 'Common/api'

import { connect } from 'react-redux'
import {
  resetNewAgreement,
  resetSelectedRefs,
  updateNewAgreement,
  updateSelectedAgreement,
  updateSelectedRefs
} from 'Actions/agreement-actions'
import { formats, purposeState, userType } from 'Common/constants'

import * as _ from 'lodash'
import { setStores, setSuppliers } from '../../redux-store/actions/data-actions'
import { withRouter } from 'react-router'
import { numeral } from 'Common/global'
import { updateUser } from '../../redux-store/actions/user-actions'
import MidMsgComponent from '../Dashboard'
import { getMainStoreFromUser } from '../../common/utils'

class EditAgreement extends Component {
  state = {
    loading: false,
    step: 1,
    selectedStores: [],
    selectedRefs: [],
    references: [],
    disableSelectSuppliers: false,
    disableSelectStore: false,
    asProposal: false
  }

  componentWillMount() {
    if (sessionStorage.getItem('token') !== null) {
      api.auth.decode().then(response => {
        window.backendApplicationVersion = response.data.applicationVersion ?
          response.data.applicationVersion : window.backendApplicationVersion ?
            window.backendApplicationVersion : null;
        this.props.updateUser({data: response.data, type: response.data.userType});
      }).catch(err => {
        console.error(err);
        this.props.updateUser({data: null, type: null});
      })
    }
  }

  increaseStep = () => {
    // Go to next step
    this.setState(prevState => {
      return { step: prevState.step + 1 }
    })
  }
  decreaseStep = () => {
    // Go to previous step
    this.setState(prevState => {
      return { step: prevState.step - 1 }
    })
  }
  goToSummary = () => {
    const {
      selectedRefs,
      selectedAgreement,
      newAgreement,
      updateSelectedRefs
    } = this.props
    // Choose the object to pick the refs from
    const refs = isEmptyObject(selectedAgreement)
      ? newAgreement.agreementDetails
      : selectedAgreement.agreementDetails
    // If the refs are different, update them
    if (JSON.stringify(selectedRefs) !== JSON.stringify(refs))
      updateSelectedRefs(refs)
    // Go to next step
    this.increaseStep()
  }

  buildAgreement(data, newAgreement = true) {
    const agreement = {
      agreementState: null,
      userName: null,
      title: null,
      userType: null,
      type: null,
      destSupplierId: null,
      origSupplierId: null,
      destSupplier: null,
      origSupplier: null,
      validFrom: null,
      validTo: null,
      allStores: false,
      asProposal: this.state.asProposal,
      agreementValidity: null,
      proposalDateLm: null,
      trash: false,
      responseDateLm: null,
      responseDateSupl: null,
      agreementPurpose: null,
      authCodeLm: null,
      totalAmount: null,
      deliveryLocation: null,
      transportCosts: null,
      redeliveryOrganization: null,
      notes: null,
      supplierNotes: null,
      userFirstName: null,
      userLastName: null,
      agreementStores: [],
      agreementDetails: [],
      proposals: []
    }

    if (_.has(data, 'agreementId')) {
      agreement.agreementId = data.agreementId
    }

    agreement.agreementState = _.get(data, 'agreementState', agreement.agreementState)
    agreement.agreementValidity = _.get(data, 'agreementValidity', agreement.agreementValidity)
    agreement.userName = _.get(data, 'userName', agreement.userName)
    agreement.title = _.get(data, 'title', agreement.title)
    agreement.userType = this.state.asProposal ? userType.AM.key : _.get(data, 'userType', agreement.userType)
    agreement.type = _.get(data, 'type', agreement.type)
    agreement.allStores = this.state.selectedStores.includes(0)
    agreement.destSupplierId = _.get(data, 'destSupplierId', agreement.destSupplierId)
    agreement.origSupplierId = _.get(data, 'origSupplierId', agreement.origSupplierId)
    agreement.authCodeLm = _.get(data, 'authCodeLm', agreement.authCodeLm)
    agreement.asProposal = _.get(data, 'asProposal', agreement.asProposal)
    agreement.validFrom = _.get(data, 'validFrom', agreement.validFrom)
    agreement.validTo = _.get(data, 'validTo', agreement.validTo)
    agreement.agreementPurpose = _.get(data, 'agreementPurpose', agreement.agreementPurpose)
    agreement.redeliveryOrganization = _.get(data, 'redeliveryOrganization', agreement.redeliveryOrganization)
    agreement.transportCosts = _.get(data, 'transportCosts', agreement.transportCosts)
    agreement.notes = _.get(data, 'notes', agreement.notes)
    agreement.trash = _.get(data, 'trash', agreement.trash);
    agreement.proposals = _.get(data, 'proposals', agreement.proposals)
    agreement.agreementDetails = _.get(data, 'agreementDetails', agreement.agreementDetails)
    agreement.destSupplier = _.get(_.find(this.props.suppliers, { num_foucom: agreement.destSupplierId }), 'description', _.get(data, 'destSupplier', null))
    agreement.origSupplier = _.get(_.find(this.props.suppliers, { num_foucom: agreement.origSupplierId }), 'description', _.get(data, 'origSupplier', null))
    agreement.totalAmount = 0
    agreement.userFirstName = _.get(data, 'userFirstName', agreement.userFirstName);
    agreement.userLastName = _.get(data, 'userLastName', agreement.userLastName);
    agreement.supplierNotes = _.get(data, 'supplierNotes', agreement.supplierNotes)

    const availableStoresIds = []

    _.forEach(agreement.agreementDetails, o => {
      _.forEach(o.connections, connection => {
        if (!availableStoresIds.includes(connection.storeId)) {
          availableStoresIds.push(connection.storeId)
        }

        if (newAgreement || agreement.agreementState === 'DRAFT') {
          connection.acceptedStock = connection.proposedStock
        }
      })

      if (newAgreement || agreement.agreementState === 'DRAFT') {
        o.acceptedPrice = o.proposedPrice
        o.acceptedQuantity = o.proposedQuantity
      }

      o.proposedPrice = numeral(numeral(o.proposedPrice).format(formats.currency)).value()
      o.acceptedPrice = numeral(numeral(o.acceptedPrice).format(formats.currency)).value()
      o.totalAmount = numeral(numeral(o.totalAmount).format(formats.currency)).value()

      agreement.totalAmount += o.totalAmount
    })

    if (_.size(agreement.proposals) === 0) {
      _.forEach(this.props.stores, store => {
        if (availableStoresIds.includes(store.storeCode)) {
          agreement.proposals.push({
            storeName: store.storeDesc,
            storeId: store.storeCode,
            state: purposeState[0].key
          })
        }
      })
    } else {
      agreement.proposals = _.filter(agreement.proposals, proposal => availableStoresIds.includes(proposal.storeId))

      const existingStoreIds = _.map(agreement.proposals, proposal => proposal.storeId)
      const diff = _.difference(availableStoresIds, existingStoreIds)

      _.forEach(this.props.stores, store => {
        if (!diff.includes(store.storeCode)) {
          return
        }

        agreement.proposals.push({
          storeName: store.storeDesc,
          storeId: store.storeCode,
          state: purposeState[0].key
        })
      })
    }

    _.forEach(agreement.proposals, proposal => proposal.connections = [])

    agreement.totalAmount = numeral(numeral(agreement.totalAmount).format(formats.currency)).value()

    return agreement
  }

  saveAgreement = () => {
    // Loading while saving
    this.setState({ loading: true })

    const isNew = isEmptyObject(this.props.selectedAgreement)
    const restProp = isNew ? 'create' : 'edit'

    const agreement = this.buildAgreement(isNew ? this.props.newAgreement : this.props.selectedAgreement, isNew)

    api.agreements[restProp](agreement).then(res => {
      api.agreements.getOne(res.data.agreementId).then(response => {
        this.setState({ loading: false })
        this.props.updateSelectedAgreement(response.data)
        this.goToAgreement(response.data.agreementId)
      }).catch(err => {
        console.error(err)
        this.setState({ loading: false })
      })
    }).catch(err => {
      console.log(err)
      this.setState({ loading: false })
    })
  }

  goToAgreement = id => {
    // Navigate to agreement
    this.props.history.push(`/view/${id}`)
  }

  updateAgreement = values => {
    // Update agreement on Redux store
    if (isEmptyObject(this.props.selectedAgreement)) {
      if ('agreementStores' in values || 'origSupplierId' in values) {
        values.agreementDetails = []
        this.setState({
          disableSelectSuppliers: !!values.agreementDetails.length,
          disableSelectStore: !!values.agreementDetails.length
        })
        //TODO: uncheck references
      }
      this.props.updateNewAgreement(values)
    } else {
      this.props.updateSelectedAgreement(values)
    }
  }

  componentWillUnmount() {
    // Reset values on Redux store when leave page
    if (!isEmptyObject(this.props.newAgreement)) this.props.resetNewAgreement()
    if (this.props.selectedRefs && this.props.selectedRefs.length > 0)
      this.props.resetSelectedRefs()
  }

  componentDidMount() {
    const { id } = this.props.match.params

    if (isEmptyObject(this.props.selectedAgreement) && this.props.location.pathname !== '/new' && this.props.location.pathname !== '/new-proposal') {
      this.viewAgreement(id);
    } else if (!isEmptyObject(this.props.selectedAgreement)) {
      const storeIds = this.getSelectedStoresFromAgreement(this.props.selectedAgreement)
      const selectedRefs = this.getSelectedRefsFromAgreement(this.props.selectedAgreement)
      this.setState({ selectedStores: storeIds, selectedRefs: selectedRefs, asProposal: this.props.selectedAgreement.asProposal === true })
    } else {
      this.setState({asProposal: this.props.asProposal === true});
    }

    this.getStores()
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.selectedAgreement !== this.props.selectedAgreement) {
      this.setState({asProposal: this.props.selectedAgreement.asProposal === true});
    }
  }

  getSelectedStoresFromAgreement(agreement) {
    let storeIds = []

    if (agreement.allStores) {
      storeIds = [0]
    } else {
      _.forEach(agreement.proposals, proposal => {
        storeIds.push(proposal.storeId)
      })

      storeIds = _.uniq(storeIds)
    }

    return storeIds
  }

  viewAgreement = id => {
    // Loading while fetching
    this.setState({ loading: true })
    // Axios GET call, fetch a single agreement passing the id
    api.agreements
      .getOne(id)
      .then(res => {
        // Stop loading
        const storeIds = this.getSelectedStoresFromAgreement(res.data)
        const selectedRefs = this.getSelectedRefsFromAgreement(res.data)
        this.setState({ loading: false, selectedStores: storeIds, selectedRefs: selectedRefs })

        // Save result on Redux store
        this.props.updateSelectedAgreement(res.data)
        this.props.updateSelectedRefs(res.data.agreementDetails)
      })
      .catch(err => {
        console.error(err)
        // Stop loading
        this.setState({ loading: false })
      })
  }

  showReferences(supplierId) {
    const supplier = supplierId ? { supplier: supplierId } : ''
    const self = this
    let mainStoreId = null;

    if (this.state.asProposal) {
      mainStoreId = getMainStoreFromUser(this.props.user);
    }

    api.references.getAll(supplier).then(res => {
      let references;

      if (self.state.asProposal) {
        references = _.filter(res.data, product => _.findIndex(product.stock, {store: mainStoreId}) > -1);
      } else {
        references = res.data;
      }

      self.setState({ references: references })
    }).catch(err => {
      console.error(err)
    })
  }

  getStores = () => {
    // Axios GET call, fetch all stores
    api.stores.getAll().then(res => {
      // this.setState({ stores: res.data.stores })
      this.props.setStores(res.data.stores)
    })
  }

  onChangeSelectedStores(selectedStores) {
    this.setState({
      selectedStores: selectedStores
    })
  }

  getSelectedRefsFromAgreement(agreement) {
    let selectedRefs = []

    _.forEach(agreement.agreementDetails, agreementDetail => {
      selectedRefs.push(agreementDetail.refLm)
    })

    selectedRefs = _.uniq(selectedRefs)

    return selectedRefs
  }

  renderSteps = () => {
    const { step, selectedRefs } = this.state
    const { newAgreement, selectedAgreement, user, stores, suppliers } = this.props
    // Choose the object to pick the data from
    const data = isEmptyObject(this.props.selectedAgreement)
      ? newAgreement
      : selectedAgreement
    // Render different content based on step number

    const isNewAgreement = isEmptyObject(this.props.selectedAgreement)
    const agreementProp = isNewAgreement ? 'newAgreement' : 'selectedAgreement'
    let disableSelectStore = false
    let canSelectRefs = true

    if (_.size(this.props[agreementProp].agreementDetails) > 0) {
      disableSelectStore = true
      canSelectRefs = true
    }

    if (_.isNil(this.props[agreementProp].origSupplierId)) {
      canSelectRefs = false
      disableSelectStore = true
    }

    switch (step) {
      case 1:
        return (
          <Row gutter={32}>
            <Col span={6}>
              <AgreementForm
                isProposal={this.state.asProposal}
                isNewAgreement={isEmptyObject(selectedAgreement)}
                disableSelectSuppliers={!isEmptyObject(this.props.newAgreement) ? !!this.props.newAgreement.agreementDetails.length : false}
                disableSelectStore={disableSelectStore}
                showReferences={supplierId => this.showReferences(supplierId)}
                onChangeCallback={this.updateAgreement}
                onChangeSelectedStores={this.onChangeSelectedStores.bind(this)}
                data={data}
                stores={stores}
                selectedStores={this.state.selectedStores}
                suppliers={suppliers}
                user={user}
              />
            </Col>
            <Col span={18}>
              {(user.type === userType.PM.key || (user.type === userType.AM.key && this.state.asProposal === true)) && (
                <Fragment>
                  <h3>Referenze corrispondenti ai criteri di ricerca</h3>
                  <RefsTable
                    isProposal={this.state.asProposal}
                    onChangeCallback={this.updateAgreement}
                    references={this.state.references}
                    stores={stores}
                    selectedStores={this.state.selectedStores}
                    selectedRefs={selectedRefs}
                    canSelectRefs={canSelectRefs}
                    selectedAgreement={selectedAgreement}
                    isNewAgreement={isEmptyObject(selectedAgreement)}
                  />
                  <Divider/>
                </Fragment>
              )}
              <h3>Referenze selezionate</h3>
              <SelectedRefsTable
                isNewAgreement={isEmptyObject(this.props.selectedAgreement)}
                onChangeCallback={this.updateAgreement}
                data={data}
                stores={stores}
                editable
                user={user}
              />
            </Col>
          </Row>
        )
      case 2:
        return <Summary data={data} user={user}/>
      default:
        return
    }
  }

  validateData(data) {
    const requiredFields = ['agreementState', 'userName', 'userType', 'type', 'destSupplierId', 'origSupplierId', 'validFrom', 'validTo', 'agreementValidity', 'agreementPurpose', 'totalAmount', 'redeliveryOrganization']
    const notZeroFields = ['totalAmount']
    const sizeNotZeroFields = ['agreementDetails']
    const notEmpty = ['title']

    for (let fieldName of requiredFields) {
      if (_.isNil(data[fieldName])) {
        return false
      }
    }

    for (let fieldName of notZeroFields) {
      const num = Number(data[fieldName])

      if (isNaN(num) || num <= 0) {
        return false
      }
    }

    for (let fieldName of sizeNotZeroFields) {
      if (_.size(data[fieldName]) === 0) {
        return false
      }
    }

    for (let fieldName of notEmpty) {
      if (_.isEmpty(data[fieldName])) {
        return false
      }
    }

    return true
  }

  confirmEditBtn() {
    if(!isEmptyObject(this.props.selectedAgreement)) {
      api.agreements
        .getOne(this.props.selectedAgreement.agreementId)
        .then(res => {
          // Stop loading
          this.setState({ viewAgreementLoading: { loading: false, id: null } })

          // Save result on Redux store
          this.props.updateSelectedAgreement(res.data)
          this.props.updateSelectedRefs(res.data.agreementDetails)
          // Navigate to the agreement view page
          this.setRedirect();
        })
        .catch(err => {
          console.error(err)
          // Stop loading
          this.setState({ viewAgreementLoading: { loading: false, id: null } })
        })

    } else {
      this.setRedirect();
    }
  }

  cancelEditBtn() {

  }

  setRedirect = () => {
    this.setState({
      redirect: true
    })
  }

  renderRedirect = (id) => {
    if (this.state.redirect) {
      return <Redirect to={'/view/' + id}/>
    }
  }

  render() {
    if (this.props.user.type === null) {
      return <MidMsgComponent title={'PAGINA NON ACCESSIBILE'} description={'L\'applicazione è accessibile soltanto attraverso i canali di autenticazione.'}/>
    }

    const { step, loading } = this.state
    // const { newAgreement, selectedAgreement } = this.props
    // Choose the object to pick the data from
    // const data = isEmptyObject(selectedAgreement)
    //   ? newAgreement
    //   : selectedAgreement
    // If there is no data, disable
    const agreement = this.buildAgreement(isEmptyObject(this.props.selectedAgreement) ? this.props.newAgreement : this.props.selectedAgreement, isEmptyObject(this.props.selectedAgreement))
    const disabled = !this.validateData(agreement)
    return (
      <MainLayout>
        {this.renderRedirect(agreement.agreementId)}
        <Row>
          <AlignRightColumn>
            {(step === 1) ? (
              agreement.agreementId &&
              <Popconfirm
              title={<div><div>Procedendo si perderanno i dati non salvati.</div><div>Si è sicuri di voler procedere?</div></div>}
              onConfirm={() => this.confirmEditBtn()}
              onCancel={() => this.cancelEditBtn()}
              okText="Conferma" cancelText="Cancella">
              <Button disabled={disabled}>
              Riepilogo
              </Button>
              </Popconfirm>
            ) : (
              <Button onClick={this.decreaseStep}>Modifica</Button>
            )}
            <MarginLeftButton
              loading={loading}
              disabled={disabled}
              type="primary"
              onClick={this.saveAgreement}>
              Salva
            </MarginLeftButton>
          </AlignRightColumn>
        </Row>
        <Divider/>
        {this.renderSteps()}
      </MainLayout>
    )
  }
}

const mapStateToProps = state => {
  return {
    newAgreement: state.Agreement.newAgreement,
    selectedAgreement: state.Agreement.selectedAgreement,
    selectedRefs: state.Agreement.selectedRefs,
    user: state.User,
    stores: state.Data.stores,
    suppliers: state.Data.suppliers
  }
}
const mapDispatchToProps = {
  updateNewAgreement,
  updateSelectedAgreement,
  resetNewAgreement,
  updateSelectedRefs,
  resetSelectedRefs,
  setStores,
  setSuppliers,
  updateUser
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(EditAgreement))



// WEBPACK FOOTER //
// ./src/containers/EditAgreement/index.js